import type {
  ApReportInferencesMap,
  InferenceEntry,
} from '@/context/services/report_inferences/utils';
import { useCallback, useEffect, useMemo, useState } from 'react';

export type InferenceBaselineField = keyof ApReportInferencesMap;

type BaselineOverrides = Partial<ApReportInferencesMap>;

export type UseInferenceBaselineReturn = {
  baseline: ApReportInferencesMap;
  overrideBaselineEntry: (
    field: InferenceBaselineField,
    entry: InferenceEntry | undefined
  ) => void;
};

const NO_OVERRIDES: BaselineOverrides = {};

export const useInferenceBaseline = (
  inferencesMap: ApReportInferencesMap
): UseInferenceBaselineReturn => {
  const [overrides, setOverrides] = useState<BaselineOverrides>(NO_OVERRIDES);

  useEffect(() => {
    setOverrides(NO_OVERRIDES);
  }, [inferencesMap]);

  const overrideBaselineEntry = useCallback(
    (field: InferenceBaselineField, entry: InferenceEntry | undefined) => {
      setOverrides((current) => ({ ...current, [field]: entry }));
    },
    []
  );

  const baseline = useMemo(
    () => ({ ...inferencesMap, ...overrides }),
    [inferencesMap, overrides]
  );

  return { baseline, overrideBaselineEntry };
};
